// extracted by mini-css-extract-plugin
export var container = "styles-module__container___if8_O";
export var logo = "styles-module__logo___qGBGt";
export var subText = "styles-module__subText___h21Nh";